import { render, staticRenderFns } from "./table-geral.vue?vue&type=template&id=0764a72c&scoped=true&"
import script from "./table-geral.vue?vue&type=script&lang=js&"
export * from "./table-geral.vue?vue&type=script&lang=js&"
import style0 from "./table-geral.vue?vue&type=style&index=0&id=0764a72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764a72c",
  null
  
)

export default component.exports